import { GeneralPropsType } from "@/common/types";
import styles from "./index.module.css";
import clsx from "clsx";
import { ModalContent, useDisclosure } from "@nextui-org/react";
import { Modal } from "@nextui-org/react";
import BottomGradientBorder from "../BottomGradientBorder";
import getIcon from "@/common/function/getIcon_bk";
import DynamicSizeIcon from "../DynamicSizeIcon";
import DynamicFontSize from "../DynamicFontSize";
import { CheckboxPrimary } from "../CheckboxPrimary";
import PrimaryButton from "../PrimaryButton";
import { useGlobalData } from "@/contexts/GlobalData";
import { useEffect, useState } from "react";
interface CheckNetworkPropsType extends GeneralPropsType {}
async function saveImageToCache(url: string) {
  const cache = await caches.open("image-cache");
  await cache.add(url);
}
async function loadImageFromCache(url: string) {
  const cache = await caches.open("image-cache");
  const response = await cache.match(url);
  const data = await response?.blob();
  if (data) {
    const src = URL.createObjectURL(data);
    console.log("🚀 ~ loadImageFromCache ~ src:", src);
    return src;
  }
  return undefined;
}
function CheckNetwork({
  children,
  className,
  onClick
}: CheckNetworkPropsType) {
  const [isOnline, setIsOnline] = useState(true);
  const [isKnown, setIsKnown] = useState(false);
  const {
    translate
  } = useGlobalData();
  const prefix = "check_network_";
  const [imageSrc, setImageSrc] = useState<{
    network?: string;
    closeModal?: string;
  } | null>(null);
  const [timer, setTimer] = useState<NodeJS.Timeout | null>(null);
  async function checkNetworkSpeed() {
    // const limitSizeInMB = 10;
    // const fileUrl = "/_next/static/chunks/app/page.js";
    // const startTime = new Date().getTime();
    // const res = await fetch(fileUrl, {
    //     method: "GET",
    //     headers: { Range: `bytes=0-${limitSizeInMB * 1024 * 1024}`, cache: "no-store" },
    // });
    // const endTime = new Date().getTime();
    // const fileSizeInMegaBit = (+(res.headers.get("content-length") || 0) * 8) / 1000000; //mega bit
    // const durationInSeconds = (endTime - startTime) / 1000;
    // const speedMbps = (fileSizeInMegaBit / durationInSeconds).toFixed(2);

    // if (!navigator.onLine && !isKnown) {
    //     if (isOpenModal) return;
    //     setIsOpenModal(true);
    //     const networkIcon = getIcon("network_red");
    //     const closeModalIcon = getIcon("close_modal");
    //     const srcCacheNetwork = await loadImageFromCache(networkIcon || "");
    //     const srcCacheCloseModal = await loadImageFromCache(closeModalIcon || "");
    //     console.log("🚀 ~ checkNetworkSpeed ~ srcCacheCloseModal:", srcCacheCloseModal, isOpenModal);
    //     setImageSrc({
    //         ...imageSrc,
    //         network: srcCacheNetwork,
    //         closeModal: srcCacheCloseModal,
    //     });
    // } else {
    //     if (!isOpenModal) return;
    //     console.log("🚀 ~ checkNetworkSpeed ~ isOpenModal:", isOpenModal);
    //     handleCloseModal();
    // }
    setIsOnline(navigator.onLine);
  }
  const handleCloseModal = async () => {
    setIsKnown(true);
    timer && clearInterval(timer);
  };
  useEffect(() => {
    (async () => {
      if (isOnline) {} else {
        const networkIcon = getIcon("network_red");
        const closeModalIcon = getIcon("close_modal");
        const srcCacheNetwork = await loadImageFromCache(networkIcon || "");
        const srcCacheCloseModal = await loadImageFromCache(closeModalIcon || "");
        setImageSrc({
          ...imageSrc,
          network: srcCacheNetwork,
          closeModal: srcCacheCloseModal
        });
      }
    })();
  }, [isOnline]);
  useEffect(() => {
    const tm = setInterval(() => {
      checkNetworkSpeed();
    }, 3000);
    setTimer(tm);
    return () => {
      timer && clearInterval(timer);
    };
  }, []);
  useEffect(() => {
    const networkIcon = getIcon("network_red");
    const closeModalIcon = getIcon("close_modal");
    if (networkIcon) {
      saveImageToCache(networkIcon);
    }
    if (closeModalIcon) {
      saveImageToCache(closeModalIcon);
    }
  }, [getIcon]);
  return <>
            {!isOnline && !isKnown && <div className={clsx(styles.appear_tooltip_modal, "fixed inset-0 bg-black/[0.64] size-full flex z-[9999]")} onClick={handleCloseModal}>
                    <div className="size-full flex">
                        <BottomGradientBorder onClick={(e: any) => e?.stopPropagation()} background="bottom_to_top" className="p-3 rounded-2xl m-auto !max-w-[calc(100%-32px)] w-[600px]">
                            <DynamicFontSize fontSize={18} className="text-white flex items-center gap-1.5">
                                {/* <DynamicSizeIcon width={20} icon={getIcon("network_red")} /> */}
                                {translate(prefix + "title")}
                                <DynamicSizeIcon width={24} icon={imageSrc?.closeModal || getIcon("close_modal")} className="ml-auto cursor-pointer" onClick={handleCloseModal} />
                            </DynamicFontSize>
                            <div className="divider my-5"></div>
                            <DynamicFontSize fontSize={13} className="flex flex-col gap-3 text-white">
                                <DynamicSizeIcon width={48} icon={imageSrc?.network || getIcon("network_red")} className="mx-auto" />
                                {/* <span className="font-bold">{translate(prefix + "warning network title")}</span> */}
                                <span className="text-description">{translate(prefix + "warning network des1")}</span>
                                <span className="text-description">{translate(prefix + "warning network des2")}</span>

                                <PrimaryButton onClick={handleCloseModal} className="w-full" statusKey={prefix + "confirm network"}></PrimaryButton>
                            </DynamicFontSize>
                        </BottomGradientBorder>
                    </div>
                </div>}
        </>;
}
export default CheckNetwork;